export default __webpack_public_path__ + "static/media/fc_icon_great_active.cbe8e0a1.svg";